import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import PropTypes from "prop-types"
import cx from "classnames"

/* TODO: Make svg icon for all other social icons and add them to the svgIcons array */
import { icons, svgIcons } from "./icons"
export { icons }
import "./library"

export const lookupSocialIcon = icon => icons.find(i => i.iconName === icon)

const FontAwesomeNameFallbacks = [
  { old: "external-link", new: "arrow-up-right-from-square" },
  { old: "shopping-cart", new: "cart-shopping" },
  { old: "telegram-plane", new: "telegram" },
  { old: "snapchat-ghost", new: "snapchat" }
]

export default function SocialIcon({ name, style, className, ...props }) {
  const svgIcon = svgIcons.find(i => i.name === name)
  if (svgIcon) {
    const IconComponent = svgIcon.component
    return (
      <IconComponent
        className={cx(className, "inline-block w-3")}
        style={{ fontSize: "inherit", ...style }}
        {...props}
      />
    )
  }
  let iconName
  if (name && typeof name == "string") {
    const oldName = FontAwesomeNameFallbacks.find(f => f.old === name)
    if (oldName) {
      iconName = lookupSocialIcon(oldName.new)
    } else {
      iconName = lookupSocialIcon(name)
    }
  }

  return (
    <FontAwesomeIcon
      icon={iconName}
      className={cx("", className)}
      style={style}
      {...props}
    />
  )
}

SocialIcon.propTypes = {
  name: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  style: PropTypes.object,
  className: PropTypes.string
}
